import request from "../utils/request";
import { endpoint } from "../utils/config";

export async function postLogin(data) {
  const url = `${endpoint}/users/login`;
  return await request({
    url,
    method: "get",
    data,
  });
}

export async function getVerifyMFA(data){ 
  const url = `${endpoint}/users/verify-otp`;
  return await request({
    url,
    method: "get",
    data,
  });
}

export async function postSignup(data) {
  const url = `${endpoint}/tenants/`;
  return await request({ url, method: "POST", data });
}

export async function postLogOut(data) {
  const url = `${endpoint}/auth/logout`;
  return await request({ url, method: "POST", data });
}

export async function putForgotPassword(data) {
  const url = `${endpoint}/users/recoverPassword/${data?.email}`;
  return await request({ url, method: "PUT" });
}

export async function putResetPassword({data, userId}) {
  const url = `${endpoint}/users/resetPassword/${userId}`;
  return await request({ url, method: "PUT", data });
}
